











































import {Component, Prop, Vue} from "vue-property-decorator";
import JsonViewer from 'vue-json-viewer'
import {Getter} from "vuex-class";

@Component({
    components: {
        JsonViewer,
        VisualComponent: () => import("@/valchrom/views/mathservice/dataset/overview/VisualComponent.vue")
    }
})
export default class ParametersAccordion extends Vue {
    @Prop() model: any;
    @Getter overview_simplify !: boolean;

    mounted() {
        this.accordionAction(undefined);
    }

    accordionAction(id: any) {
        var accordionButton: any = null;
        if (id) {
            accordionButton = document.getElementById(id);
            var contentOfAccordion: any = document!.getElementById(id)!.nextSibling
            if (contentOfAccordion!.style!.display == "block") {
                contentOfAccordion!.style!.display = "none"
                accordionButton!.classList.remove("is-primary");
            } else if (contentOfAccordion.style.display == "none") {
                contentOfAccordion.style.display = "block"
                accordionButton!.classList.add("is-primary");
            } else if (contentOfAccordion.style.display == "") {
                contentOfAccordion.style.display = "block"
                accordionButton!.classList.add("is-primary");
            }
        }
        var otherAccordions = Array.from(document.getElementsByClassName("accordionButton"))
        otherAccordions.forEach(function (otherAccordionButton) {
            if (accordionButton != otherAccordionButton) {
                var content: any = otherAccordionButton.nextSibling
                content!.style!.display = "none"
                otherAccordionButton.classList.remove("is-primary");
            }
        })
    }
}
